export const NO_TRANSLATE_CLASS = 'notranslate'

export const NO_TRANSLATE_PROPS = {
  translate: 'no'
}

export const PRODUCT_IDENTITY_CATEGORY_IDS = [
  'tyre',
  'rim',
  'completeWheel'
]

export const PRODUCT_IDENTITY_CATEGORY_SLUGS = [
  'dack',
  'dekk',
  'falg',
  'felg',
  'hjulpaket'
]

export const shouldPreventProductIdentityTranslation = (category) => {
  const categoryId = typeof category === 'string' ? category : category && category.id
  return PRODUCT_IDENTITY_CATEGORY_IDS.includes(categoryId)
}

export const shouldPreventProductIdentityTranslationBySlug = (slug) => (
  PRODUCT_IDENTITY_CATEGORY_SLUGS.includes(slug)
)
